import {
  PenTool,
  SquarePen,
  Image,
  LayoutTemplate,
  TrendingUp,
  Palette,
  Mic,
  AlignLeft,
  Layers,
} from "lucide-react"

// Static metadata for the dashboard launchpad service tiles (Atrium Stage 4).
//
// ⚠️ NO PRICES HERE. "From" prices are computed server-side from the live
// PriceList (Pricing::LaunchpadPricing) and differ by Insider status, so the
// dashboard passes them in as `launchpad.prices[key]` ({ from, amount, unit }).
// `key` (kebab) matches Pricing::LaunchpadPricing::SERVICES.
//
// ⚠️ ROUTES: every tile deep-links into Post a Project (Stage 7) with the
// service preselected, landing on the wizard's FOCUSED "name & launch" arrival
// (not the full picker). `service` is the wizard key (the JobPosting boolean the
// wizard flips, CustomerPostProjectPresenter::SERVICES), NOT the kebab `key`.
// Returning-customer rows append `&repeat=1` to pre-fill the project name; the
// new-customer grid links plain. `repeatable: false` opts a service out of the
// name pre-fill (Book Writing — the natural name is the not-yet-known title).
// The Bundle banner opens the bundle catalog (`/post?path=bundle`); picking a
// tier is a real choice, so it never goes focused.

export const SERVICES = [
  {
    key: "book-writing",
    service: "book_writing",
    name: "Book Writing",
    blurb: "Ghostwriting, fiction & non-fiction",
    Icon: PenTool,
    repeatable: false,
  },
  {
    key: "editing",
    service: "editing",
    name: "Editing",
    blurb: "Line, copy & developmental",
    Icon: SquarePen,
    repeatable: true,
  },
  {
    key: "cover-design",
    service: "cover_design",
    name: "Cover Design",
    blurb: "Front, spine & back covers",
    Icon: Image,
    repeatable: true,
  },
  {
    key: "formatting",
    service: "formatting",
    name: "Formatting",
    blurb: "Print & eBook interiors",
    Icon: LayoutTemplate,
    repeatable: true,
  },
  {
    key: "seo-articles",
    service: "seo",
    name: "SEO Articles",
    blurb: "Search-optimized web copy",
    Icon: TrendingUp,
    repeatable: true,
  },
  {
    key: "illustration",
    service: "illustration",
    name: "Illustration",
    blurb: "Children's book & artwork",
    Icon: Palette,
    repeatable: true,
  },
  {
    key: "narration",
    service: "narration",
    name: "Audiobook Narration",
    blurb: "Pro voice narration",
    Icon: Mic,
    repeatable: true,
  },
  {
    key: "book-description",
    service: "book_description",
    name: "Book Description",
    blurb: "Back-cover blurb & metadata",
    Icon: AlignLeft,
    repeatable: true,
  },
]

export const BUNDLE = {
  key: "book-bundles",
  name: "Book Bundles",
  blurb: "Writing, cover, editing and formatting, handled together.",
  tag: "Best value",
  Icon: Layers,
  href: "/post?path=bundle",
}

// The deep-link a launchpad tile points at. Returning-customer rows pass
// repeat=true so the focused arrival pre-fills the project name (skipped for
// non-repeatable services like Book Writing).
export function serviceHref(svc, { repeat = false } = {}) {
  const base = `/post?service=${svc.service}`
  return repeat && svc.repeatable ? `${base}&repeat=1` : base
}
